( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '#start-form-btn' ).on( 'click', function() {
        $( 'body' ).addClass( 'mpf__show-form' );
      } );
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( currentPage == $( '.gform_page' ).length ) {
          $( 'body' ).addClass( 'last-mpf-page' );
        } else {
          $( 'body' ).removeClass( 'last-mpf-page' );
        }
      } );
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( 'body' ).addClass( 'mpf__is-confirmation' );
        $( '.gform_confirmation_message' ).addClass( 'wysiwyg theme-bg-light' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
